import { createSlice } from '@reduxjs/toolkit';
import { getContentTypeForBodyType } from '../../../constants/integrations/webhookData';
import webhookState from '../../../constants/integrations/webhookState';

export const webhooksSlice = createSlice({
  name: 'webhooks',
  initialState: webhookState,
  reducers: {
    setWebhookName: (state, action) => {
      state.data.title = action.payload;
    },
    setWebhookDescription: (state, action) => {
      state.data.description = action.payload;
    },
    setWebhookEndpointUrl: (state, action) => {
      state.data.integrationData.endpointUrl = action.payload;
    },
    setWebhookHeaders: (state, action) => {
      state.data.integrationData.headers = action.payload;
    },
    setWebhookBodyType: (state, action) => {
      state.data.integrationData.body.type = action.payload;

      state.data.integrationData.headers = state.data.integrationData.headers.map(header =>
        header.key === 'Content-Type'
          ? { ...header, value: getContentTypeForBodyType(action.payload) }
          : header
      );
    },
    setWebhookBodyTemplate: (state, action) => {
      state.data.integrationData.body.template = action.payload;
    },
    setWebhookCreationType: (state, action) => {
      state.etc.creationType = action.payload;
    },
    setWebhookIntegrationId: (state, action) => {
      state.etc.integrationId = action.payload;
    },
    setWebhookData: (state, action) => {
      state.data = action.payload;
    },
    setWebhookStep: (state, action) => {
      state.etc.webhookStep = action.payload;
    },
    setWebhookNextStep: state => {
      state.etc.webhookStep = state.etc.webhookStep + 1;
    },
    setWebhookPreviousStep: state => {
      state.etc.webhookStep = state.etc.webhookStep - 1;
    },
    resetWebhookState: () => webhookState(),
  },
});

export const {
  setWebhookName,
  setWebhookDescription,
  setWebhookEndpointUrl,
  setWebhookHeaders,
  setWebhookBodyType,
  setWebhookBodyTemplate,
  setWebhookCreationType,
  setWebhookIntegrationId,
  setWebhookData,
  setWebhookStep,
  setWebhookNextStep,
  setWebhookPreviousStep,
  resetWebhookState,
} = webhooksSlice.actions;

export default webhooksSlice.reducer;
